/**
 * Отформатировать число в человекочитаемый вид (добавить пробелы между порядками).
 * 212824 -> "212 824"
 * */
const formatNumber = (num: number | string) => {
  if (typeof num !== 'number' && typeof num !== 'string') return ''

  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
}

/**
 * Получить нужное склонение числительного
 * numWord(value, ['товар', 'товара', 'товаров']);
 * */
const numWord = (value: number, words: [string, string, string]) => {
  const absValue = Math.abs(value)
  const lastTwoDigits = absValue % 100
  const lastDigit = absValue % 10

  if (lastTwoDigits > 10 && lastTwoDigits < 20) return words[2]
  if (lastDigit > 1 && lastDigit < 5) return words[1]
  if (lastDigit === 1) return words[0]
  return words[2]
}

/**
 * Форматирует телефон в вид: +7 (XXX) XXX-XX-XX
 * Принимает строку с любыми символами
 */
const formatPhone = (phone: string): string => {
  const digits = phone.replace(/\D/g, '')

  if (digits.length === 0) return ''

  // Нормализация к +7
  let normalized = digits

  if (digits.length === 11 && digits.startsWith('8')) {
    normalized = '7' + digits.slice(1)
  }

  if (normalized.length !== 11 || !normalized.startsWith('7')) {
    // если номер не российский — просто возвращаем как есть
    return phone
  }

  const [, a, b, c, d] = normalized.match(/^7(\d{3})(\d{3})(\d{2})(\d{2})$/)!

  return `+7 (${a}) ${b}-${c}-${d}`
}

const formatUtils = { formatNumber, numWord, formatPhone }
export default formatUtils
